export const categories = [
  {
    id: "consumer",
    icon: "ri-shopping-bag-3-line",
    name: "消费维权",
    desc: "虚假宣传、售后推诿、预付费跑路等消费纠纷线索。",
    count: 1284,
  },
  {
    id: "workplace",
    icon: "ri-briefcase-4-line",
    name: "职场内幕",
    desc: "用工不规范、加班与薪酬争议、招聘造假等职场问题。",
    count: 976,
  },
  {
    id: "industry",
    icon: "ri-line-chart-line",
    name: "行业观察",
    desc: "同业竞争、供应链操作、行业潜规则的内部视角。",
    count: 823,
  },
  {
    id: "society",
    icon: "ri-building-2-line",
    name: "社会民生",
    desc: "社区治理、公共服务、民生设施等与日常生活相关的线索。",
    count: 751,
  },
  {
    id: "entertainment",
    icon: "ri-movie-2-line",
    name: "文娱八卦",
    desc: "演出、影视、内容行业的台前幕后与真实生态。",
    count: 690,
  },
  {
    id: "tech",
    icon: "ri-cpu-line",
    name: "科技互联网",
    desc: "数据使用、产品套路、平台规则的业内见闻。",
    count: 612,
  },
  {
    id: "health",
    icon: "ri-heart-pulse-line",
    name: "医疗健康",
    desc: "就诊体验、药品与器械、健康服务中的真实情况。",
    count: 538,
  },
  {
    id: "education",
    icon: "ri-book-open-line",
    name: "教育升学",
    desc: "培训机构、招生宣传、校园服务等教育相关线索。",
    count: 447,
  },
];